import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Input, Select } from '@rallyshift/design-system'
import api, { PlatformOrganizationSummary } from '../../api/client'

const PlatformEmailPage: React.FC = () => {
  const [orgs, setOrgs] = useState<PlatformOrganizationSummary[]>([])
  const [organizationId, setOrganizationId] = useState('')
  const [to, setTo] = useState('')
  const [configured, setConfigured] = useState<boolean | null>(null)
  const [error, setError] = useState('')
  const [result, setResult] = useState<{
    ok: boolean
    error?: string
    from: string
    to: string[]
    mode: string
  } | null>(null)
  const [sending, setSending] = useState(false)

  useEffect(() => {
    Promise.all([api.platform.listOrganizations(), api.platform.emailStatus()])
      .then(([list, status]) => {
        setOrgs(list)
        setConfigured(status.emailConfigured)
        if (list[0]) setOrganizationId(list[0].id)
      })
      .catch((e: Error) => setError(e.message || 'E-mailstatus kon niet worden geladen.'))
  }, [])

  const send = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!organizationId) {
      setError('Kies een organisatie. Afzender, kleur en reply-to komen daar vandaan.')
      return
    }
    setSending(true)
    setError('')
    setResult(null)
    try {
      const response = await api.platform.emailTest({
        organization_id: organizationId,
        to: to.trim() || undefined,
      })
      setResult(response)
    } catch (err: any) {
      setError(err.message || 'Versturen is niet gelukt.')
    } finally {
      setSending(false)
    }
  }

  const options = orgs.map((o) => ({ value: o.id, label: `${o.name} (${o.slug})` }))

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-display-md text-text-primary">E-mailtest</h1>
        <p className="mt-1 text-md text-text-secondary">
          Stuurt een echte testmail via Resend. Een adres dat jij typt bewijst dat deze
          server mail kan afleveren. Leeg laten stuurt naar de beheerders van de
          organisatie, het pad dat een echte melding gebruikt.
        </p>
      </div>

      {configured === false && (
        <Alert variant="warning">
          RESEND_API_KEY is niet gezet. De test zal falen totdat die op de server staat.
        </Alert>
      )}

      {error && (
        <Alert variant="danger" onDismiss={() => setError('')}>
          {error}
        </Alert>
      )}

      {result && (
        <Alert variant={result.ok ? 'success' : 'danger'}>
          {result.ok
            ? `Verstuurd van ${result.from} naar ${result.to.join(', ')}.`
            : result.error || 'Versturen is niet gelukt.'}
        </Alert>
      )}

      <Card>
        <form onSubmit={send} className="space-y-4">
          <Select
            label="Organisatie"
            value={organizationId}
            onChange={(e) => setOrganizationId(e.target.value)}
            options={options}
          />
          <Input
            label="Adres (optioneel)"
            type="email"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            hint="Leeg = de beheerders van de organisatie."
          />
          <Button type="submit" loading={sending} disabled={!organizationId}>
            Test versturen
          </Button>
        </form>
      </Card>
    </div>
  )
}

export default PlatformEmailPage
